"use client";

import React, { useEffect } from "react";
import Chatbot from "../components/Chatbot";
import Footer from "../components/common/Footer"

function Projects() {
  useEffect(() => {
    // Mobile menu toggle
    const menuBtn = document.getElementById("menu-btn");
    const mobileMenu = document.getElementById("mobile-menu");

    const handleMenuToggle = () => {
      if (mobileMenu) {
        mobileMenu.classList.toggle("hidden");
      }
    };

    if (menuBtn) {
      menuBtn.addEventListener("click", handleMenuToggle);
    }

    // Tab functionality
    const tabButtons = document.querySelectorAll(".tab-button");
    const projectTabs = document.querySelectorAll(".project-tab");

    tabButtons.forEach((button) => {
      button.addEventListener("click", () => {
        // Deactivate all buttons and hide all tabs
        tabButtons.forEach((btn) => {
          btn.classList.remove("active");
          btn.classList.remove("bg-indigo-950", "text-white");
          btn.classList.add("text-gray-600", "hover:bg-gray-200");
        });
        projectTabs.forEach((tab) => tab.classList.add("hidden"));

        // Activate the clicked button and show the corresponding tab
        button.classList.add("active");
        button.classList.remove("text-gray-600", "hover:bg-gray-200");
        button.classList.add("bg-indigo-950", "text-white");

        const tabId = button.dataset.tab;
        document.getElementById(`${tabId}-tab`).classList.remove("hidden");
      });
    });

    // Initialize the first tab as active
    if (tabButtons.length > 0) {
      tabButtons[0].classList.add("active");
      tabButtons[0].classList.remove("text-gray-600", "hover:bg-gray-200");
      tabButtons[0].classList.add("bg-indigo-950", "text-white");
    }
    if (projectTabs.length > 0) {
      projectTabs[0].classList.remove("hidden");
    }

    return () => {
      if (menuBtn) {
        menuBtn.removeEventListener("click", handleMenuToggle);
      }
      tabButtons.forEach((button) => {
        button.removeEventListener("click", () => { });
      });
    };
  }, []);

  return (
    <div>
      <Chatbot />

      <main className="flex overflow-hidden flex-col pb-11 bg-white">
        {/* Hero Section */}
        <header className="flex relative flex-col items-center self-stretch px-20 pb-36 w-full text-white min-h-[457px] max-md:px-5 max-md:pb-24 max-md:max-w-full">
          <img
            src="assets/img/project-bg.png"
            alt="Hero Background"
            className="object-cover absolute inset-0 size-full"
          />

          <nav className="flex items-center justify-between w-full max-w-[1248px] px-5 py-3 relative mx-auto">
            {/* Logo */}
            <img
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/6f92263fde794fd91fb10442848bed84da061cb6?placeholderIfAbsent=true&apiKey=a6aeafbfb8ee495fa82398b0de2ab431"
              alt="Company logo"
              className="w-[101px] object-contain"
            />

            {/* Mobile Menu Button */}
            <button id="menu-btn" className="block md:hidden text-white focus:outline-none">
              <svg
                className="w-8 h-8"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16m-7 6h7"
                ></path>
              </svg>
            </button>

            {/* Navigation Wrapper */}
            <div id="menu" className="hidden md:flex relative items-center">
              {/* Background behind menu */}
              <div className="absolute inset-0 w-full h-full bg-white rounded-full"></div>

              {/* Menu Items */}
              <ul className="flex gap-10 px-8 py-3 text-indigo-950 text-base font-medium relative z-10">
                <li className="cursor-pointer">
                  <a href="/">Home</a>
                </li>
                <li className="cursor-pointer">
                  <a href="/services">Services</a>
                </li>
                <li className="font-bold cursor-pointer">
                  <a href="/projects">Projects</a>
                </li>
                <li className="cursor-pointer">
                  <a href="/about">About</a>
                </li>
              </ul>
            </div>

            {/* Contact Button */}
            <button className="px-5 py-2 bg-white text-indigo-950 font-bold rounded-full hidden md:block">
              <a href="/contact">Contact Us</a>
            </button>

            {/* Mobile Dropdown */}
            <div id="mobile-menu" className="absolute top-full left-0 w-full bg-white shadow-md hidden md:hidden">
              <ul className="flex flex-col items-center gap-4 py-4 text-indigo-950 font-medium">
                <li className="cursor-pointer">
                  <a href="/">Home</a>
                </li>
                <li className="cursor-pointer">
                  <a href="/services">Services</a>
                </li>
                <li className="cursor-pointer">
                  <a href="/projects">Projects</a>
                </li>
                <li className="cursor-pointer">
                  <a href="/about">About</a>
                </li>
                <li>
                  <a href="/contact">
                    <button className="px-5 py-2 bg-white text-indigo-950 font-bold rounded-full">
                      Contact Us
                    </button>
                  </a>
                </li>
              </ul>
            </div>
          </nav>

          <p className="relative  mt-20 text-base text-center text-white w-[417px]">Our Projects</p>
          <h1 className="relative  text-6xl font-semibold text-center text-white max-md:max-w-full max-md:text-4xl">
            Our Legacy of <br />
            Excellence
          </h1>
        </header>

        <div className="container">
          <header className="text-center">
            <h1 className="z-10 text-4xl font-semibold text-center text-black max-w-3xl mx-auto">
              Empowering Businesses & Homes with Reliable Electrical Solutions
            </h1>
            <p className="mt-8 text-base text-center text-black max-w-xl mx-auto">
              Powering progress with expert electrical & solar solutions! Explore our projects and see innovation in
              action.
            </p>
          </header>

          {/* Tab Pills Navigation */}
          <nav className="flex justify-center mt-20 max-md:mt-10" id="projectTabs">
            <div className="flex gap-2 p-1 bg-gray-100 rounded-full">
              <button
                data-tab="solar"
                className="px-6 py-2 text-sm font-medium text-white bg-indigo-950 rounded-full transition-all tab-button active"
              >
                Solar Panels
              </button>
              <button
                data-tab="electrical"
                className="px-6 py-2 text-sm font-medium text-gray-600 rounded-full hover:bg-gray-200 transition-all tab-button"
              >
                Electrical Work
              </button>
              <button
                data-tab="welding"
                className="px-6 py-2 text-sm font-medium text-gray-600 rounded-full hover:bg-gray-200 transition-all tab-button"
              >
                Welding Work
              </button>
            </div>
          </nav>

          {/* Solar Projects (Default Visible) */}
          <div id="solar-tab" className="project-tab active">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12 max-w-6xl mx-auto">
              {/* Project Card 1 */}
              <div className="bg-white rounded-2xl overflow-hidden shadow-lg relative group">
                <div className="relative h-24 overflow-hidden">
                  <img
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/cf35c5a2a3e5cc83a94e8a6ade5f0e0bee9493b9"
                    alt="120KW Solar System"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-black/30"></div>
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-gray-900">12 KW Max power Hybrid</h3>
                  <p className="mt-2 text-gray-600">
                    Our team successfully installed 120KW Max Power hybrid solar system at Memon Gath Karachi.
                  </p>
                  <div className="flex flex-wrap gap-2 mt-4">
                    <span className="px-3 py-1 text-sm font-medium bg-blue-100 text-indigo-950 rounded-full">
                      Project Code: 0027
                    </span>
                    <span className="px-3 py-1 text-sm font-medium bg-orange-100 text-indigo-950 rounded-full">
                      Memon Goth Karachi
                    </span>
                  </div>
                </div>
              </div>

              {/* Project Card 2 */}
              <div className="bg-white rounded-2xl overflow-hidden shadow-lg relative group">
                <div className="relative h-24 overflow-hidden">
                  <img
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/93be9aee09c4b2b48603c85aae2133cf2c82fd32"
                    alt="10KW Growatt System"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-black/30"></div>
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-gray-900">10 KW Growatt</h3>
                  <p className="mt-2 text-gray-600">
                    Our team successfully installed 10KW Growatt solar system at Main Cantt Karachi.
                  </p>
                  <div className="flex flex-wrap gap-2 mt-4">
                    <span className="px-3 py-1 text-sm font-medium bg-blue-100 text-indigo-950 rounded-full">
                      Project Code: 0026
                    </span>
                    <span className="px-3 py-1 text-sm font-medium bg-orange-100 text-indigo-950 rounded-full">
                      Main cantt Karachi
                    </span>
                  </div>
                </div>
              </div>

              {/* Project Card 3 */}
              <div className="bg-white rounded-2xl overflow-hidden shadow-lg relative group">
                <div className="relative h-24 overflow-hidden">
                  <img
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/632f65a091136962e959e133ad42061c0a12a5d0"
                    alt="8KW Nitrox System"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-black/30"></div>
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-gray-900">8 KW Nitrox</h3>
                  <p className="mt-2 text-gray-600">
                    Our team successfully installed 08KW Nitrox solar system at North Nazimabad Karachi.
                  </p>
                  <div className="flex flex-wrap gap-2 mt-4">
                    <span className="px-3 py-1 text-sm font-medium bg-blue-100 text-indigo-950 rounded-full">
                      Project Code: 0025
                    </span>
                    <span className="px-3 py-1 text-sm font-medium bg-orange-100 text-indigo-950 rounded-full">
                      North Nazimabad Karachi
                    </span>
                  </div>
                </div>
              </div>

              {/* Project Card 4 */}
              <div className="bg-white rounded-2xl overflow-hidden shadow-lg relative group">
                <div className="relative h-24 overflow-hidden">
                  <img
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/03a3667a64f10910ed6353d4adda5760164a4b5a"
                    alt="10KW On-Grid Growatt System"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-black/30"></div>
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-gray-900">10 KW On-Grid Growatt Setup</h3>
                  <p className="mt-2 text-gray-600">
                    Our team successfully installed 10KW On-Grid Growatt solar system at Karachi.
                  </p>
                  <div className="flex flex-wrap gap-2 mt-4">
                    <span className="px-3 py-1 text-sm font-medium bg-blue-100 text-indigo-950 rounded-full">
                      Project Code: 0024
                    </span>
                    <span className="px-3 py-1 text-sm font-medium bg-orange-100 text-indigo-950 rounded-full">
                      Karachi
                    </span>
                  </div>
                </div>
              </div>

              {/* Project Card 5 */}
              <div className="bg-white rounded-2xl overflow-hidden shadow-lg relative group">
                <div className="relative h-24 overflow-hidden">
                  <img
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/25243ed53020d00b1f8014557d4ee87386ea8103"
                    alt="Solar panel installation"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-black/30"></div>
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-gray-900">15 KW On-Grid Growatt Setup</h3>
                  <p className="mt-2 text-gray-600">
                    Our team successfully installed 15KW On-Grid Growatt solar system at Malir Cantt Karachi.
                  </p>
                  <div className="flex flex-wrap gap-2 mt-4">
                    <span className="px-3 py-1 text-sm font-medium bg-blue-100 text-indigo-950 rounded-full">
                      Project Code: 0023
                    </span>
                    <span className="px-3 py-1 text-sm font-medium bg-orange-100 text-indigo-950 rounded-full">
                      Malir Cantt Karachi
                    </span>
                  </div>
                </div>
              </div>

              {/* Project Card 6 */}
              <div className="bg-white rounded-2xl overflow-hidden shadow-lg relative group">
                <div className="relative h-24 overflow-hidden">
                  <img
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/92a270e1c1ab5b3def8ef7de2ba669ddf42a6116"
                    alt="10KW On-Grid Growatt System"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-black/30"></div>
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-gray-900">10 KW On-Grid Growatt Step</h3>
                  <p className="mt-2 text-gray-600">
                    Our team successfully installed 10KW On-Grid Growatt solar system at Malir Cantt Bazar Karachi.
                  </p>
                  <div className="flex flex-wrap gap-2 mt-4">
                    <span className="px-3 py-1 text-sm font-medium bg-blue-100 text-indigo-950 rounded-full">
                      Project Code: 0022
                    </span>
                    <span className="px-3 py-1 text-sm font-medium bg-orange-100 text-indigo-950 rounded-full">
                      Malir Cantt Bazar Block E, Karachi
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Electrical Projects (Hidden by Default) */}
          <div id="electrical-tab" className="project-tab hidden">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12 max-w-6xl mx-auto">
              {/* Dummy Electrical Project 1 */}
              <div className="bg-white rounded-2xl overflow-hidden shadow-lg relative group">
                <div className="relative h-24 overflow-hidden">
                  <img
                    src="https://actionservicesgroup.com/wp-content/uploads/2023/03/The-Different-Types-of-Commercial-Electrical-Wiring-3.23.23.jpg"
                    alt="Commercial Wiring"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-black/30"></div>
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-gray-900">Commercial Wiring Project</h3>
                  <p className="mt-2 text-gray-600">
                    Complete electrical wiring solution for 10-story commercial building in downtown Karachi.
                  </p>
                  <div className="flex flex-wrap gap-2 mt-4">
                    <span className="px-3 py-1 text-sm font-medium bg-blue-100 text-indigo-950 rounded-full">
                      Project Code: E001
                    </span>
                    <span className="px-3 py-1 text-sm font-medium bg-orange-100 text-indigo-950 rounded-full">
                      I.I. Chundrigar Road
                    </span>
                  </div>
                </div>
              </div>

              {/* Dummy Electrical Project 2 */}
              <div className="bg-white rounded-2xl overflow-hidden shadow-lg relative group">
                <div className="relative h-24 overflow-hidden">
                  <img
                    src="https://teagueelectric.com/wp-content/uploads/2023/09/house-rewiring.jpg"
                    alt="Home Rewiring"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-black/30"></div>
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-gray-900">Residential Rewiring</h3>
                  <p className="mt-2 text-gray-600">
                    Complete electrical rewiring for heritage home in Clifton with modern safety features.
                  </p>
                  <div className="flex flex-wrap gap-2 mt-4">
                    <span className="px-3 py-1 text-sm font-medium bg-blue-100 text-indigo-950 rounded-full">
                      Project Code: E002
                    </span>
                    <span className="px-3 py-1 text-sm font-medium bg-orange-100 text-indigo-950 rounded-full">
                      Clifton Block 2
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Welding Projects (Hidden by Default) */}
          <div id="welding-tab" className="project-tab hidden">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12 max-w-6xl mx-auto">
              {/* Dummy Welding Project 1 */}
              <div className="bg-white rounded-2xl overflow-hidden shadow-lg relative group">
                <div className="relative h-24 overflow-hidden">
                  <img
                    src="https://swantonweld.com/wp-content/uploads/2024/01/structural-steel-tower.jpg"
                    alt="Steel Structure"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-black/30"></div>
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-gray-900">Industrial Steel Structure</h3>
                  <p className="mt-2 text-gray-600">
                    Custom steel structure fabrication and installation for industrial warehouse in SITE area.
                  </p>
                  <div className="flex flex-wrap gap-2 mt-4">
                    <span className="px-3 py-1 text-sm font-medium bg-blue-100 text-indigo-950 rounded-full">
                      Project Code: W001
                    </span>
                    <span className="px-3 py-1 text-sm font-medium bg-orange-100 text-indigo-950 rounded-full">
                      SITE Superhighway
                    </span>
                  </div>
                </div>
              </div>

              {/* Dummy Welding Project 2 */}
              <div className="bg-white rounded-2xl overflow-hidden shadow-lg relative group">
                <div className="relative h-24 overflow-hidden">
                  <img
                    src="https://www.rsgsecurity.co.uk/images/RSG3000-residential-project-security-door-gates.jpg"
                    alt="Metal Gates"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-black/30"></div>
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-gray-900">Security Gate Fabrication</h3>
                  <p className="mt-2 text-gray-600">
                    Custom ornamental security gates for residential complex in DHA Phase 5.
                  </p>
                  <div className="flex flex-wrap gap-2 mt-4">
                    <span className="px-3 py-1 text-sm font-medium bg-blue-100 text-indigo-950 rounded-full">
                      Project Code: W002
                    </span>
                    <span className="px-3 py-1 text-sm font-medium bg-orange-100 text-indigo-950 rounded-full">
                      DHA Phase 5
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Services Section Header */}

        <section className="flex flex-wrap gap-10 mt-40 w-full max-md:mt-10 max-md:max-w-full px-4">
          <header className="flex flex-col self-start text-black">
            <h2 className="self-start text-4xl font-semibold">Meet Our Team</h2>
            <p className="mt-5 text-base">
              Seamless solar integration for efficient and sustainable industrial power!
            </p>
          </header>
          <div className="flex-auto max-md:max-w-full" data-el="div-5">
            <div className="flex gap-5 max-md:flex-col">
              <div className="w-6/12 max-md:ml-0 max-md:w-full">
                <div className="max-md:mt-5">
                  <article className="flex relative flex-col w-full rounded-3xl aspect-[0.628] max-md:h-[500px]">
                    <img
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/539cee164fbfb4afea7310d8f611391a0e1f141d?placeholderIfAbsent=true&apiKey=a6aeafbfb8ee495fa82398b0de2ab431"
                      alt="Syed Akram Ali Shah"
                      className="object-cover absolute inset-0 w-full h-full"
                    />
                    <div className="absolute inset-0 bg-black opacity-50 rounded-3xl"></div>{" "}
                    {/* Dark overlay */}
                    <div className="flex relative flex-col pt-96 pr-9 pb-6 pl-3.5 rounded-3xl max-md:pt-24 max-md:pr-5">
                      <h3 className="text-2xl font-semibold text-white">Syed Akram Ali Shah</h3>
                      <p className="self-start text-base text-white">Founder</p>
                    </div>
                  </article>
                  <article className="flex relative flex-col mt-5 w-full rounded-3xl aspect-[0.628] max-md:h-[500px]">
                    <img
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/05beb34ca08c2e2b67f245dc5013387fa6a70245?placeholderIfAbsent=true&apiKey=a6aeafbfb8ee495fa82398b0de2ab431"
                      alt="Syed Rameez Ali Shah"
                      className="object-cover absolute inset-0 w-full h-full"
                    />
                    <div className="absolute inset-0 bg-black opacity-50 rounded-3xl"></div>{" "}
                    {/* Dark overlay */}
                    <div className="flex relative flex-col items-start pt-96 pr-14 pb-6 pl-3.5 rounded-3xl max-md:pt-24 max-md:pr-5">
                      <h3 className="text-2xl font-semibold text-white">Syed Rameez Ali Shah</h3>
                      <p className="text-base text-white">CEO</p>
                    </div>
                  </article>
                </div>
              </div>
              <div className="ml-5 w-6/12 max-md:ml-0 max-md:w-full">
                <div className="grow mt-10">
                  <article className="flex relative flex-col w-full rounded-3xl aspect-[0.628] max-md:h-[500px]">
                    <img
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/e372be01b3db79db0e9d755b021b6207e8de8b9a?placeholderIfAbsent=true&apiKey=a6aeafbfb8ee495fa82398b0de2ab431"
                      alt="Jamal Khan"
                      className="object-cover absolute inset-0 w-full h-full"
                    />
                    <div className="absolute inset-0 bg-black opacity-50 rounded-3xl"></div>{" "}
                    {/* Dark overlay */}
                    <div className="flex relative flex-col px-3.5 pt-96 pb-6 rounded-3xl max-md:pt-24">
                      <h3 className="text-2xl font-semibold text-white"> Jamal Khan</h3>
                      <p className="self-start text-base text-white">Assistant Manager</p>
                    </div>
                  </article>
                  <article className="flex relative flex-col mt-16 w-full rounded-3xl aspect-[0.628] max-md:mt-10 max-md:h-[500px]">
                    <img
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/a3fdd9444b6fb6b32929632d076d85ce5cb6fd12?placeholderIfAbsent=true&apiKey=a6aeafbfb8ee495fa82398b0de2ab431"
                      alt="Faheem Khan"
                      className="object-cover absolute inset-0 w-full h-full"
                    />
                    <div className="absolute inset-0 bg-black opacity-50 rounded-3xl"></div>{" "}
                    {/* Dark overlay */}
                    <div className="flex relative flex-col items-start pt-96 pr-14 pb-6 pl-3.5 rounded-3xl max-md:pt-24 max-md:pr-5">
                      <h3 className="text-2xl font-semibold text-white">Faheem Khan</h3>
                      <p className="text-base text-white">Safety Officer</p>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <div className="power-up-container">
        <div className="power-up-content">
          <h1 className="font-medium">Let's Power Up Together!</h1>
          <p className="text-[17px] my-5 text-gray-600">
            Have questions or need expert electrical and solar solutions?
            <br />
            Our team is ready to assist you. Get in touch today!
          </p>

          <div className="power-up-form">
            <input type="text" placeholder="Enter Your Name" />
            <input type="text" placeholder="Write Your Phone" />
            <select>
              <option value="">Select Service</option>
              <option>Solar Solutions</option>
              <option>Street Pole</option>
              <option>Electrical Services</option>
            </select>
            <button>Get Free Quotation</button>
          </div>
        </div>

        <div className="power-up-image">
          <img src="assets/img/man.png" alt="Man with headphones" />
        </div>
      </div>
      {/* Footer */}
      <Footer />
    </div>
  );
}

export default Projects;